export enum PromotionRewardType {
  Message = 'Message',
  IncentiveMessageReward = 'IncentiveMessageReward',
  Discount = 'Discount',
  NewPrice = 'NewPrice',
  AmountOff = 'AmountOff',
  Percent = 'Percent',
  Points = 'Points',
  None = '',
  StoredValue = 'STORED_VALUE',
}
